import PropTypes from 'prop-types';

import { SvgStyled } from './TrlFlag.styles';

export const TrlFlag = ({ flag, ...rest }) => (
  <SvgStyled {...rest}>
    <use xlinkHref={`symbol-defs.svg#${flag}_TL`} />
  </SvgStyled>
);
TrlFlag.propTypes = {
  flag: PropTypes.string,
  small: PropTypes.bool,
};
